import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from "@angular/material/dialog";
import {ISetBuildingRoomValues, StagingService} from "../../../new-information/services/staging.service";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {finalize} from "rxjs";
import {ModalWindowComponent} from "../../../std-components/modal-window/modal-window.component";
import {CommonModule} from "@angular/common";
import {NgxMaskDirective, provideNgxMask} from "ngx-mask";

@Component({
  selector: 'app-create-parking-detail',
  templateUrl: './create-parking-detail.component.html',
  styleUrl: './create-parking-detail.component.scss',
  standalone: true,
  imports: [
    ModalWindowComponent,
    CommonModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    MatDialogClose
  ],
  providers: [
    provideNgxMask()
  ]
})
export class CreateParkingDetailComponent implements OnInit {

  readonly dialogRef = inject(MatDialogRef<CreateParkingDetailComponent>);
  readonly data = inject<{ room: ISetBuildingRoomValues }>(MAT_DIALOG_DATA);

  form = new FormGroup({
    buildingID: new FormControl(),
    buildingRoomID: new FormControl(), /*id ячейки*/
    roomTypeItemID: new FormControl(),
    floorID: new FormControl(),
    placeNumber: new FormControl(), /*Номер паркоместа **/
    area: new FormControl(), /*Общая площадь **/
    roomTypeItemTitle: new FormControl(),
  });

  get roomTypeItemTitle() {
    return this.form.get('roomTypeItemTitle') as FormControl;
  }

  constructor(private stagingService: StagingService,
              private toastr: ToastrService) {
  }

  ngOnInit() {
    this.form.patchValue(this.data.room);
  }

  loadingSave = false;

  save() {
    this.loadingSave = true;
    const object: ISetBuildingRoomValues = this.form.value as ISetBuildingRoomValues;
    this.stagingService.setBuildingRoomValues(object)
      .pipe(
        finalize(() => this.loadingSave = false)
      )
      .subscribe({
        next: (_) => {
          this.toastr.success('Изменения сохранены!', 'Успешно!');
          this.dialogRef.close(this.form.value);
        },
        error: (err) => {
          console.log(err)
        },
      })
  }


}
